export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13341.c1a58192.jpg";